import * as React from 'react';
import { DateTime, Info } from 'luxon';
import Base, { Props as BaseProps } from '../Base/Base';
import DatePickerDay from './DatePickerDay';
import DatePickerGrid from './DatePickerGrid';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import Text from '../Text/Text';

const daysOfTheWeek = Info.weekdays('short');
const daysCount = 6 * 7;

interface Props extends BaseProps {
  dateSelectableFrom?: DateTime;
  dateSelectableTo?: DateTime;
  dateSelectedFrom?: DateTime;
  dateSelectedTo?: DateTime;
  onNextMonth: () => void;
  onPreviousMonth: () => void;
  onSelect: (date: DateTime) => void;
  viewDate: DateTime;
}

const DatePickerMonth: React.FunctionComponent<Props> = (props: Props) => {
  const {
    dateSelectableFrom,
    dateSelectableTo,
    dateSelectedFrom,
    dateSelectedTo,
    onNextMonth,
    onPreviousMonth,
    onSelect,
    viewDate,
    ...rest
  } = props;

  return (
    <Base { ...rest }>
      <Flex
          alignChildren="middle"
          direction="horizontal"
          gap="x4"
          margin="x4"
          paddingHorizontal="x12">
        <Flex>
          <Link onClick={ onPreviousMonth }>
            <Icon name="ChevronLeft" />
          </Link>
        </Flex>

        <Flex grow>
          <Text align="middle">{ viewDate.toFormat('MMMM yyyy') }</Text>
        </Flex>

        <Flex>
          <Link onClick={ onNextMonth }>
            <Icon name="ChevronRight" />
          </Link>
        </Flex>
      </Flex>

      <DatePickerGrid margin="x1">
        { daysOfTheWeek.map((day) => (
          <Text
              align="middle"
              key={ day }
              paddingVertical="x4"
              size="x2"
              textColor="gray-5"
              uppercase>
            { day }
          </Text>
        )) }
      </DatePickerGrid>

      <DatePickerGrid
          paddingVertical="x2">
        { Array.from({ length: daysCount }).map((_, i) => (
          <DatePickerDay
              dateSelectableFrom={ dateSelectableFrom }
              dateSelectableTo={ dateSelectableTo }
              dateSelectedFrom={ dateSelectedFrom }
              dateSelectedTo={ dateSelectedTo }
              key={ i }
              n={ i + 1 }
              onSelect={ onSelect }
              viewDate={ viewDate } />
        )) }
      </DatePickerGrid>
    </Base>
  );
};

export default DatePickerMonth;
